import axios from 'axios';

const apiUrl = __APIURL__;

// axios 1.x percent-encodes brackets in param names (fields.date[gte] etc.),
// which axios 0.21 left literal. Keep the legacy serialization so request URLs
// stay byte-identical for the Cloudflare worker's cache keys.
function serialize(params) {
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');
}

export function getEntries(query) {
  return axios.get(`${apiUrl}/entries`, { params: query, paramsSerializer: { serialize } });
}

export function getEntry(entryId) {
  return axios.get(`${apiUrl}/entries/${entryId}`);
}

export function getAsset(assetId) {
  return axios.get(`${apiUrl}/assets/${assetId}`);
}
